import { render, staticRenderFns } from "./NativeScrollableContent.vue?vue&type=template&id=0fef7406&scoped=true&"
import script from "./NativeScrollableContent.vue?vue&type=script&lang=js&"
export * from "./NativeScrollableContent.vue?vue&type=script&lang=js&"
import style0 from "./NativeScrollableContent.vue?vue&type=style&index=0&id=0fef7406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef7406",
  null
  
)

export default component.exports